export enum LegTypeEnum {
  air = 'Air',
  ground = 'Ground',
  accommodation = 'Accommodation',
}

export enum SegmentTypeEnum {
  hospital = 'HubToDonorHospital',
  txcenter = 'DonorHospitalToTxCenter',
  hub = 'TxCenterToHub',
  reposition = 'Reposition',
  returnToBase = 'ReturnToBase',
  dhToHub = 'DonorHospitalToHub',
  custom = 'Custom',
}

export enum LegLocationTypeEnum {
  homeResidence = 'HomeResidence',
  airport = 'Airport',
  hub = 'Hub',
  hospital = 'Hospital',
  txcenter = 'TxCenter',
  custom = 'Custom',
}

export enum LegLocationReferenceTypeEnum {
  airport = 'AirportLocationRequest',
  facility = 'FacilityLocationRequest',
  custom = 'CustomAddressRequest',
}

export enum TransportProviderTypes {
  TMDX = 'Tmdx',
  Commercial = 'Commercial',
  Partner = 'Partner',
  SupplementalLiftProvider = 'SupplementalLiftProvider',
  TMDXAffiliate = 'TMDXAffiliate',
  TxCenter = 'TxCenter',
  Curri = 'Curri',
  Teds = 'Teds',
  SelfServiced = 'SelfServiced',
}

export enum RouteTypeEnum {
  Main = 'Main',
  DryRun = 'DryRun',
}

export enum RouteSnapshotType {
  AviationApproved = 'AviationApproved',
  QuoteApproved = 'QuoteApproved',
  QuoteRecalled = 'QuoteRecalled',
}

export enum RouteLegTypeEnum {
  AccommodationLeg = 'AccommodationLeg',
  CommercialFlightAviaLeg = 'CommercialFlightAviaLeg',
  CurriServiceGroundLeg = 'CurriServiceGroundLeg',
  SupplementalLiftAviaLeg = 'SupplementalLiftAviaLeg',
  TmdxAffiliateGroundLeg = 'TmdxAffiliateGroundLeg',
  TxCenterProviderGroundLeg = 'TxCenterProviderGroundLeg',
  TxCenterProviderAviaLeg = 'TxCenterProviderAviaLeg',
  TmdxJetAviaLeg = 'TmdxJetAviaLeg',
  TmdxDriveAffiliateGroundLeg = 'TmdxDriveAffiliateGroundLeg',
  TmdxDriveTedsGroundLeg = 'TmdxDriveTedsGroundLeg',
  SelfServicedGroundLeg = 'SelfServicedGroundLeg',
}

export enum ResponseRouteLegTypeEnum {
  AccommodationLeg = 'AccommodationRouteLegResponse',
  CommercialFlightAviaLeg = 'CommercialFlightAviaRouteLegResponse',
  CurriServiceGroundLeg = 'CurriServiceGroundLegResponse',
  SupplementalLiftAviaLeg = 'SupplementalLiftAviaLegResponse',
  TmdxAffiliateGroundLeg = 'TmdxAffiliateGroundLegResponse',
  TxCenterProviderGroundLeg = 'TxCenterProviderGroundLegResponse',
  TxCenterProviderAviaLeg = 'TxCenterProviderAviaLegResponse',
  TmdxJetAviaLeg = 'TmdxJetAviaLegResponse',
  TmdxDriveTedsGroundLeg = 'TmdxDriveTedsGroundLegResponse',
  TmdxDriveAffiliateGroundLeg = 'TmdxDriveAffiliateGroundLegResponse',
  SelfServicedGroundLeg = 'SelfServicedGroundLegResponse',
}

export enum CommercialLegType {
  Manual = 'Manual',
  Sabre = 'Sabre',
}

export enum SuggestedRouteLegCandidateType {
  TmdxJetAviaLegCandidateRequest = 'TmdxJetAviaLegCandidateRequest',
  TmdxAffiliateGroundLegCandidateRequest = 'TmdxAffiliateGroundLegCandidateRequest',
  CommercialFlightAviaLegCandidateRequest = 'CommercialFlightAviaLegCandidateRequest',
  AccommodationLegCandidateRequest = 'AccommodationLegCandidateRequest',
  TmdxDriveAffiliateGroundLegCandidateRequest = 'TmdxDriveAffiliateGroundLegCandidateRequest',
  TmdxDriveTedsGroundLegCandidateRequest = 'TmdxDriveTedsGroundLegCandidateRequest',
}

export enum EventOperationType {
  NoChange = 'NoChange',
  Added = 'Added',
  Modified = 'Modified',
  Removed = 'Removed',
}

export enum LogisticsChangeLogType {
  // "Add" leg logs
  TmdxJetAviaLegAddedLog = 'TmdxJetAviaLegAddedLog',
  SupplementalLiftAviaLegAddedLog = 'SupplementalLiftAviaLegAddedLog',
  TxCenterProviderAviaLegAddedLog = 'TxCenterProviderAviaLegAddedLog',
  CommercialFlightAviaLegAddedLog = 'CommercialFlightAviaLegAddedLog',
  SabreCommercialAviaLegsAddedLog = 'SabreCommercialAviaLegsAddedLog',
  AccommodationLegAddedLog = 'AccommodationLegAddedLog',
  TmdxAffiliateGroundLegAddedLog = 'TmdxAffiliateGroundLegAddedLog',
  TxCenterProviderGroundLegAddedLog = 'TxCenterProviderGroundLegAddedLog',
  CurriServiceGroundLegAddedLog = 'CurriServiceGroundLegAddedLog',
  TmdxDriveAffiliateGroundLegAddedLog = 'TmdxDriveAffiliateGroundLegAddedLog',
  TmdxDriveTedsGroundLegAddedLog = 'TmdxDriveTedsGroundLegAddedLog',
  SelfServicedGroundLegAddedLog = 'SelfServicedGroundLegAddedLog',
  // "Modify" leg logs
  TmdxJetAviaLegModifiedLog = 'TmdxJetAviaLegModifiedLog',
  SupplementalLiftAviaLegModifiedLog = 'SupplementalLiftAviaLegModifiedLog',
  TxCenterProviderAviaLegModifiedLog = 'TxCenterProviderAviaLegModifiedLog',
  CommercialFlightAviaLegModifiedLog = 'CommercialFlightAviaLegModifiedLog',
  SabreCommercialAviaLegModifiedLog = 'SabreCommercialAviaLegModifiedLog',
  TmdxAffiliateGroundLegModifiedLog = 'TmdxAffiliateGroundLegModifiedLog',
  TxCenterProviderGroundLegModifiedLog = 'TxCenterProviderGroundLegModifiedLog',
  CurriServiceGroundLegModifiedLog = 'CurriServiceGroundLegModifiedLog',
  AccommodationLegModifiedLog = 'AccommodationLegModifiedLog',
  TmdxDriveAffiliateGroundLegModifiedLog = 'TmdxDriveAffiliateGroundLegModifiedLog',
  TmdxDriveTedsGroundLegModifiedLog = 'TmdxDriveTedsGroundLegModifiedLog',
  SelfServicedGroundLegModifiedLog = 'SelfServicedGroundLegModifiedLog',
  // "Remove" leg logs
  TmdxJetAviaLegRemovedLog = 'TmdxJetAviaLegRemovedLog',
  SupplementalLiftAviaLegRemovedLog = 'SupplementalLiftAviaLegRemovedLog',
  TxCenterProviderAviaLegRemovedLog = 'TxCenterProviderAviaLegRemovedLog',
  CommercialFlightAviaLegRemovedLog = 'CommercialFlightAviaLegRemovedLog',
  SabreCommercialAviaGroupRemovedLog = 'SabreCommercialAviaGroupRemovedLog',
  TmdxAffiliateGroundLegRemovedLog = 'TmdxAffiliateGroundLegRemovedLog',
  TxCenterProviderGroundLegRemovedLog = 'TxCenterProviderGroundLegRemovedLog',
  CurriServiceGroundLegRemovedLog = 'CurriServiceGroundLegRemovedLog',
  AccommodationLegRemovedLog = 'AccommodationLegRemovedLog',
  TmdxDriveAffiliateGroundLegRemovedLog = 'TmdxDriveAffiliateGroundLegRemovedLog',
  TmdxDriveTedsGroundLegRemovedLog = 'TmdxDriveTedsGroundLegRemovedLog',
  SelfServicedGroundLegRemovedLog = 'SelfServicedGroundLegRemovedLog',
  // Ground trip assigned logs
  GroundTripToAffiliateLegAssignedLog = 'GroundTripToAffiliateLegAssignedLog',
  GroundTripToTedsLegAssignedLog = 'GroundTripToTedsLegAssignedLog',
  // Ground trip reassigned logs
  GroundTripToAffiliateLegReassignedLog = 'GroundTripToAffiliateLegReassignedLog',
  GroundTripToTedsLegReassignedLog = 'GroundTripToTedsLegReassignedLog',
  // "Hub" logs
  RouteDepartureHubAssignedLog = 'RouteDepartureHubAssignedLog',
  RouteDepartureHubUnassignedLog = 'RouteDepartureHubUnassignedLog',
  RouteArrivalHubAssignedLog = 'RouteArrivalHubAssignedLog',
  RouteArrivalHubUnassignedLog = 'RouteArrivalHubUnassignedLog',
  // Route logs
  RouteRemovedLog = 'RouteRemovedLog',
  SuggestedRoutesAppliedLog = 'SuggestedRoutesAppliedLog',
  PartialSuggestedRoutesAppliedLog = 'PartialSuggestedRoutesAppliedLog',
  // Resource logs
  LogisticsResourceSwappedLog = 'LogisticsResourceSwappedLog',
  LogisticsResourceRemovedLog = 'LogisticsResourceRemovedLog',
}

export enum RemovedLegTypeEnum {
  AccommodationLegLog = 'AccommodationLegLog',
  AviaLegLog = 'AviaLegLog',
  GroundLegLog = 'GroundLegLog',
}

export enum ModifiedResourceTypeEnum {
  AircraftLogResourceChanges = 'AircraftLogResourceChanges',
  CrewLogResourceChanges = 'CrewLogResourceChanges',
  OcsConsoleLogResourceChanges = 'OcsConsoleLogResourceChanges',
  EmployeeLogResourceChanges = 'EmployeeLogResourceChanges',
}

export enum DeviceTrackingLogTypeEnum {
  AirTrackingNodeAddedLogModel = 'AirTrackingNodeAddedLogModel',
  AirTrackingNodeEtaModifiedLogModel = 'AirTrackingNodeEtaModifiedLogModel',
  AirTrackingNodeModifiedLogModel = 'AirTrackingNodeModifiedLogModel',
  AirTrackingNodeRemovedLogModel = 'AirTrackingNodeRemovedLogModel',
  AirTrackingNodeStaModifiedLogModel = 'AirTrackingNodeStaModifiedLogModel',
  ArrivalTimeRecalculatedLogModel = 'ArrivalTimeRecalculatedLogModel',
  DeviceTrackingCreatedLogModel = 'DeviceTrackingCreatedLogModel',
  DisplaySettingsModifiedLogModel = 'DisplaySettingsModifiedLogModel',
  DisplaySettingsResetLogModel = 'DisplaySettingsResetLogModel',
  GroundTrackingCheckpointCompletedLogModel = 'GroundTrackingCheckpointCompletedLogModel',
  GroundTrackingNodeCompletedLogModel = 'GroundTrackingNodeCompletedLogModel',
  GroundTrackingNodeAddedLogModel = 'GroundTrackingNodeAddedLogModel',
  GroundTrackingNodeEtaModifiedLogModel = 'GroundTrackingNodeEtaModifiedLogModel',
  GroundTrackingNodeModifiedLogModel = 'GroundTrackingNodeModifiedLogModel',
  GroundTrackingNodeRemovedLogModel = 'GroundTrackingNodeRemovedLogModel',
}
